import React from 'react';
import sprintf from 'sprintf';

class SMSocialLineLink extends React.Component {
  constructor(props) {
    super(props);
    this.clickLineLink = this.clickLineLink.bind(this);
  }

  clickLineLink() {
    // Google Analytics
    const gaLabel = this.props.gaLabel;
    if (typeof ga != 'function') {
      return;
    }
    ga('send', 'event', 'button', 'click', gaLabel);
  }

  render() {
    const subject = this.props.subject;
    const body = this.props.body;
    const lineUrl = sprintf("http://line.me/R/msg/text/?%s", encodeURIComponent(subject + " " + body));

    return (
      <a href={lineUrl} target="_blank" onClick={this.clickLineLink} className="social-link__line referral__social-link-line">
        <i className="icon-spm-line"></i>
      </a>
    );
  }
}

export default SMSocialLineLink;



// WEBPACK FOOTER //
// ./app/javascript/components/social/SMSocialLineLink.jsx